import React from 'react';
import rocket from '../../../images/rocket.png';
import '../Style/popUp.css';

const DeployLoading = () => (
    <div className='popup-warning'>
        <div className='deploy-loading-container'>
            <img alt='rocket icon' src={rocket} className='deploy-loading-img'/>
            <p className='deploy-loading-main-title'>Preparing  activation</p>
            <p className='deploy-loading-sub-title'>Please wait...</p>
        </div>
    </div>
);

export default DeployLoading;
